const store = {
	// 当前store的 id 标识
	name: 'GlobalStore',
	function: (): any => {
		return {};
	}
};

export { store };
